import '../assets/css/blogs.css';
import blog1 from '../assets/images/blogs/blog-1.jpg';
import blog2 from '../assets/images/blogs/blog-2.jpg';
import blog3 from '../assets/images/blogs/blog-3.jpg';
import blog4 from '../assets/images/blogs/blog-4.jpg';
import blog5 from '../assets/images/blogs/blog-5.jpg';

const blogsDetails =
    [
        {
            title: "Blog 1",
            description: "Exciting blogs coming soon! Stay tuned.",
            image: blog1,
            color: '#0b9eed',
            link: null
        },
        {
            title: "Blog 2",
            description: "Something amazing is on the way. Check back soon!",
            image: blog2,
            color: '#f69a84',
            link: null
        },
        {
            title: "Blog 3",
            description: "New blogs are on their way. Stay connected!",
            image: blog3,
            color: '#47939a',
            link: null
        },
        {
            title: "Blog 4",
            description: "We're working on some great content. Check back soon!",
            image: blog4,
            color: '#83456a',
            link: null
        },
        {
            title: "Blog 5",
            description: "Great reads are coming your way. Stay tuned!",
            image: blog5,
            color: '#c499b8',
            link: null
        }
    ]

const Blogs = () => {
    return (
        <div className="blogs-container">
            <h1 className="heading">Blogs</h1>
            <div className="blogs-sub-container">
                <div className="blogs-card-container">
                    {
                        blogsDetails.map((blog, index) => {
                            return <div className="blogs-card" >
                                <div className="blogs-card-box" style={{ '--clr': blog.color }}>
                                    <span style={{ '--i': '0' }}></span>
                                    <span style={{ '--i': '1' }}></span>
                                    <span style={{ '--i': '2' }}></span>
                                    <span style={{ '--i': '3' }}></span>

                                    <img src={blog.image} />
                                    <div className="blogs-card-box-content">
                                        <h2>{blog.title}</h2>
                                        <p>{blog.description}</p>
                                        <a href={blog.link !== null && blog.link !== undefined ? blog.link : "#"}>Read More</a>
                                    </div>
                                </div>
                            </div>
                        })
                    }
                </div>
            </div>
        </div>
    );
}

export default Blogs;